export const aboutUs = {
  title1: "Quiénes somos",
  title2: "Contamos con la metodología, la herramienta y el equipo que llevará a su empresa a la Transformación Digital con la gestión inteligente de procesos",
  title3: "Quienes Somos",
}
